import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

interface Props extends SvgIconProps {}

const PieChartWhiteIcon = ({ ...props }: Props) => {
  return (
    <SvgIcon width={72} height={72} viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M33 6V66C17.79 64.5 6 51.63 6 36C6 20.37 17.79 7.5 33 6ZM39.09 6V32.97H66C64.59 18.75 53.28 7.41 39.09 6ZM39.09 39.03V66C53.31 64.59 64.59 53.25 66 39.03H39.09Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export default PieChartWhiteIcon;
